import { isObjectDefined } from "./object";

type StringNumber = number | string;

export const convertPotentialStringToNumber = (
  number: StringNumber,
): number | null => {
  if (!isObjectDefined(number)) {
    return null;
  }
  const parsedNumber = typeof number === "string" ? parseFloat(number) : number;
  return Number.isNaN(parsedNumber) ? null : parsedNumber;
};

export const areNumbersDifferent = (
  a: number | string | null | undefined,
  b: number | string | null | undefined,
): boolean => {
  const numA = convertPotentialStringToNumber(a) ?? null;
  const numB = convertPotentialStringToNumber(b) ?? null;

  return numA !== numB;
};
export const normalizePhoneForPhoneField = (numero: string) => {
  if (!numero) return "";
  const cleaned = numero.replace(/\s+/g, "");
  if (cleaned.startsWith("+")) return cleaned;
  if (cleaned.startsWith("0")) return "+33" + cleaned.slice(1); // FR
  return cleaned;
};

export const roundNumber = (number: number): number =>
  Math.round(number * 100) / 100;
